<template>
  <v-card-text class="inserted-values px-9 pt-3">
    <v-row>
      <v-col cols="3" class="request-label">
        Požadovaný termín zahájení
      </v-col>

      <v-col cols="9" class="request-value">
        {{ dateFormatting(individualTrialOperation.startDate) || missingValueString }}
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="3" class="request-label">
        Požadovaný termín ukončení
      </v-col>

      <v-col cols="9" class="request-value">
        {{ dateFormatting(individualTrialOperation.endDate) || missingValueString }}
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="3" class="request-label">
        Telefon
      </v-col>

      <v-col cols="9" class="request-value">
        {{ formatPhoneNumber(individualTrialOperation.phone) || missingValueString }}
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="3" class="request-label">
        E-mail
      </v-col>

      <v-col cols="9" class="request-value">
        {{ individualTrialOperation.email || missingValueString }}
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="3" class="request-label">
        Příloha
      </v-col>

      <v-col cols="9" class="request-value">
        <a
          v-if="file && file.url"
          :href="file.url"
          @click.prevent="fileDownload($event)"
        >
          {{ file.name || missingValueString }}
        </a>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="3" class="request-label">
        Poznámka
      </v-col>

      <v-col cols="9" class="request-value">
        {{ individualTrialOperation.note || missingValueString }}
      </v-col>
    </v-row>
  </v-card-text>
</template>

<script>
import { formatPhoneNumber } from '@/components/mixins/formatPhoneNumber';

export default {
  name: 'IndividualTrialOperationInsertedValues',
  mixins: [formatPhoneNumber],
  props: {
    individualTrialOperation: {
      type: Object,
      required: false,
    },
    file: {
      type: Object,
      required: false,
    },
  },
  methods: {
    fileDownload(event) {
      this.downloadFile(event, `requests/files/${this.file.uuid}`);
    },
  },
};
</script>
